import { Link, useLocation } from "react-router-dom";
import { Check, Globe2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGUAGE_CODES, LANGUAGE_LABELS, langFromPath, localizePath } from "@/i18n/lang";

export default function LanguageToggle({ className = "" }: { className?: string }) {
  const { pathname } = useLocation();
  const current = langFromPath(pathname);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className={`min-h-[48px] gap-2 px-3 ${className}`} aria-label={current === "he" ? "בחירת שפה" : current === "ru" ? "Выбрать язык" : "Choose language"}>
          <Globe2 className="h-4 w-4" aria-hidden="true" />
          <span className="hidden sm:inline">{LANGUAGE_LABELS[current]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        <DropdownMenuLabel>{current === "he" ? "שפה" : current === "ru" ? "Язык" : "Language"}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGUAGE_CODES.map((lang) => (
          <DropdownMenuItem key={lang} asChild>
            <Link to={localizePath(pathname, lang)} hrefLang={lang === "he" ? "he-IL" : lang} className="flex min-h-[48px] cursor-pointer justify-between gap-4">
              <span lang={lang}>{LANGUAGE_LABELS[lang]}</span>
              {lang === current ? <Check className="h-4 w-4 text-accent" aria-hidden="true" /> : null}
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}